// src/pages/Landing/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LandingDesktop from "./LandingDesktop";
import LandingMobile from "./LandingMobile";

export default function Landing() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/app" replace />;
  }

  return isMobile ? <LandingMobile /> : <LandingDesktop />;
}
